export const UPDATE_CART = 'UPDATE_CART';

export const CHECK_COUPON = 'CHECK_COUPON';
export const APPLY_COUPON = 'APPLY_COUPON';
export const CHECK_COUPON_FAILED = 'CHECK_COUPON_FAILED';

export const NEW_RESERVATION = 'NEW_RESERVATION';
export const NEW_RESERVATION_FINISH = 'NEW_RESERVATION_FINISH';
export const NEW_RESERVATION_FAILED = 'NEW_RESERVATION_FAILED';

export const DELETE_RESERVATION = 'DELETE_RESERVATION';
export const DELETE_RESERVATION_FINISH = 'DELETE_RESERVATION_FINISH';
export const DELETE_RESERVATION_FAILED = 'DELETE_RESERVATION_FAILED';
